import moment from 'moment';
import i18n, { tbase } from '@/i18n';
import generalStore from '@/store/index';
import { api } from '@/services/Api';
import swal from 'sweetalert2';
import q from 'q';

const methods = {
    formatTime(incomeData: string | null) {
        return moment(incomeData, 'HH:mm:ss').format('HH:mm');
    },
    formatLocalDateTime(incomeData: string | null, format = 'DD/MM/YYYY HH:mm') {
        if (!incomeData) return '';
        return moment.utc(incomeData).local().format(format);
    },
    formatLocalDateTimeIsrael(incomeData: string | null, format = 'DD/MM/YYYY HH:mm') {
        if (!incomeData) return '';
        return moment.utc(incomeData).format(format);
    },
    moment_parse(date: string | null, format?: string) {
        format = format ?? 'DD/MM/YYYY';
        return date ? moment(date, format) : null;
    },
    moment(date: Date, format?: string) {
        format = format ?? 'DD/MM/YYYY';
        return date ? moment.utc(date).local().format(format) : '';
    },
    momentlocal(date: Date, format?: string) {
        format = format ?? 'DD/MM/YYYY';
        return date ? moment(date).format(format) : '';
    },
    phone(number: string) {
        if (number) return '+' + number;
        return number;
    },
    number(number: string) {
        if (!number) return number;
        return Number(number).toLocaleString('he');
    },
    momentchat(date: Date, format: string = '', nonUtc: boolean = false) {
        if (!date) return '';
        if (!format) format = 'DD/MM/YYYY HH:mm:ss';
        let d = nonUtc ? moment(date) : moment.utc(date).local();
        return moment().isSame(d, 'day') ? d.format('HH:mm:ss') : d.format(format);
    },
    // function wrote by ChatGPT and improved by Benjamin & Aibek :)
    lastUpdatedString(dateString: string) {
        const date = new Date(dateString);
        const now = generalStore.state.CurrentDate;
        const diff = Math.round((now.getTime() - date.getTime()) / 1000);
        let value = 0;
        let label = '';
        if (diff < 60) {
            return i18n.global.t('general.lastUpdatedText.recently');
        } else if (diff < 3600) {
            value = Math.round(diff / 60);
            label = value === 1 ? 'minute' : 'minutes';
        } else if (diff < 86400) {
            value = Math.round(diff / 3600);
            label = value === 1 ? 'hour' : 'hours';
        } else if (diff < 604800) {
            value = Math.round(diff / 86400);
            label = value === 1 ? 'day' : 'days';
        } else if (diff < 2592000) {
            value = Math.round(diff / 604800);
            label = value === 1 ? 'week' : 'weeks';
        } else if (diff < 31536000) {
            value = Math.round(diff / 2592000);
            label = value === 1 ? 'month' : 'months';
        } else {
            value = Math.round(diff / 31536000);
            label = value === 1 ? 'year' : 'years';
        }
        return i18n.global.t('general.lastUpdatedText.dateAgo', { value, label: tbase('date', label) });
    },
    async getExcelTemplate() {
        swal.showLoading();
        const apiPromise = api.GetExcelTemplate();
        await q.delay(400);
        const response = await apiPromise;
        if (response.Error || !response.Data) {
            swal.fire(response.ErrorMessage || 'Oops...', '', 'warning');
            return;
        }
        swal.close();
        const blob = new Blob([response.Data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'import_template.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },
    getLinks(inputString: string) {
        try {
            // Parse the input string as JSON
            var jsonArray = JSON.parse(inputString);

            // Ensure that the parsed result is an array
            if (Array.isArray(jsonArray)) {
                // Filter the array to include only valid URLs
                var urlRegex = /(https?:\/\/[^\s]+)/;
                var linksArray = jsonArray.filter((item) => urlRegex.test(item));

                return linksArray;
            } else {
                return [];
            }
        } catch (error) {
            return [];
        }
    },
};
export default {
    methods,
};

export function useMixins() {
    return methods;
}
